/**
 * DemoBanner — persistent top bar shown when the user is in a demo session.
 * Non-dismissible; informational only.
 * Rendered by App.js when user.is_demo === true.
 */
export function DemoBanner() {
  return (
    <div
      className="bg-brand-ink text-brand-on-ink text-sm font-medium text-center py-1.5 px-4"
      role="banner"
      aria-label="Demo mode notice"
    >
      Demo mode — data resets nightly at midnight AEST. All changes are temporary.
    </div>
  );
}

export default DemoBanner;
